import React from 'react';
import { Image } from 'antd';
import { FallbackImage } from 'ui/UploadImage/fallBack/FallBackImage';
import { FarmData } from 'types/FarmData';
import { FarmGaleriesWrapper } from './style';

interface Props {
  farm: FarmData | undefined;
}

const Galeries: React.FC<Props> = ({ farm }) => {
  const { PreviewGroup } = Image;

  return (
    <FarmGaleriesWrapper>
      <div className="gallery-images-wrapper">
        <PreviewGroup>
          {farm?.images.map((galery, index) => (
            <FallbackImage
              key={index}
              src={galery.url_original ?? ''}
              type={'FarmGalery'}
              className={'farm-gallery-image-container'}
              preview={true}
            />
          ))}
        </PreviewGroup>
      </div>

      {farm?.youtube_link && (
        <div className="youtube-video-wrapper">
          <iframe
            src={`https://www.youtube.com/embed/${extractYouTubeId(farm.youtube_link)}`}
            title="Farm Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      )}
    </FarmGaleriesWrapper>
  );
};

export default Galeries;

function extractYouTubeId(url: string): string | null {
  const match = url.match(
    /(?:youtube\.com.*(?:\/|v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  );
  return match ? match[1] : null;
}
